import React from "react";

import { Grid, TableCell, TableRow, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
  row: {
    height: 72,
  },
}));

const DayHoursSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <TableRow role="checkbox" className={classes.row}>
      <TableCell padding="checkbox">
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Grid container>
          <Grid item xs={10}>
            <Skeleton />
          </Grid>
          <Grid item xs={2}>
            <Skeleton />
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default DayHoursSkeleton;
